import React, { Component } from 'react';
import withAuth from '../components/withAuth';
import { compose } from "redux";
import { connect } from "react-redux";
import { getLocalAgency } from '../redux/companies/extranetCompaniesActions';
import { Button, Card, CardContent, CardHeader, Icon, Link, Tooltip } from '@material-ui/core';
import { CONTACT_LINK, WORKORDER_PHONE_NUMBER } from '../constants'
import CustomizedTextField from '../components/Input/CustomizedTextField';
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from '@material-ui/icons/Email';
import { formatAddress, mobileAndTabletCheck } from '../utils';

class ContactUs extends Component {

    constructor(props) {
        super(props);
        this.props.getLocalAgency(this.props.activeUser.id, this.props.sites.sites, this.props.sites.selectedSite);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.getLocalAgency(this.props.activeUser.id, this.props.sites.sites, this.props.sites.selectedSite);
    }

    onPhoneNumberClick() {
        document.location.href = "tel:" + WORKORDER_PHONE_NUMBER;
    }

    onCompanyPhoneNumberClick() {
        document.location.href = "tel:" + this.props.localAgency.after_sales_phone;
    }

    onCompanyEmailClick() {
        document.location.href = "mailto:" + this.props.localAgency.after_sales_email;
    }

    redirectToContactUsForm() {
        window.open(CONTACT_LINK, "_blank");
    }

    launchMaps() {
        let strAddress = this.props.localAgency.street
            .concat(this.props.localAgency.zip)
            .concat(" ")
            .concat(this.props.localAgency.city);

        let uri = "geo:?q=";
        uri = uri.concat(encodeURIComponent(strAddress));
        window.open(uri);
    }

    render() {
        if (this.props.localAgency === null)
            return null;

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding-only-small-screen">
                <Card className="card offset-lg-2 col-lg-8 offset-md-2 col-md-8 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Pour toutes demandes d'intervention, vous pouvez nous appeler au numéro suivant:"} />
                    <CardContent className="row">
                        <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                            <CustomizedTextField
                                value={
                                    WORKORDER_PHONE_NUMBER
                                }
                                id="phone"
                                label="Téléphone"
                                disabled
                                className="full_size control-margin-top"
                            />
                        </div>
                        <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                            <Button
                                className="div-center"
                                variant="contained"
                                size="small"
                                onClick={this.onPhoneNumberClick.bind(this)}
                            >
                                <PhoneIcon />
                            </Button>
                        </div>
                    </CardContent>
                </Card>
                <Card className="card offset-lg-2 col-lg-8 offset-md-2 col-md-8 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Pour toutes autres demandes, vous pouvez contacter votre agence locale"} />
                    <CardContent>
                        <div className="row">

                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={formatAddress(this.props.localAgency)}
                                    id="company-address"
                                    multiline
                                    label={"Adresse"}
                                    disabled
                                    className="full_size control-margin-top"
                                />
                            </div>
                            {mobileAndTabletCheck() ? (
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Tooltip id="tooltip-icon" title="Allons-y">
                                        <Button
                                            className="div-center"
                                            variant="contained"
                                            size="small"
                                            onClick={this.launchMaps.bind(this)}
                                        >
                                            <Icon>location_on</Icon>
                                        </Button>
                                    </Tooltip>
                                </div>
                            ) : null}
                        </div>
                        <CustomizedTextField
                            value={this.props.localAgency.manager}
                            id="company-manager"
                            label={"Responsable"}
                            disabled
                            className="full_size control-margin-top"
                        />
                        <div className="row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={this.props.localAgency.after_sales_phone}
                                    id="company-phone"
                                    label="Téléphone"
                                    disabled
                                    className="full_size control-margin-top"
                                />
                            </div>
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button
                                    className="div-center"
                                    variant="contained"
                                    size="small"
                                    onClick={this.onCompanyPhoneNumberClick.bind(this)}
                                >
                                    <PhoneIcon />
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={this.props.localAgency.after_sales_email}
                                    id="company-email"
                                    label="Email"
                                    disabled
                                    className="full_size control-margin-top"
                                />
                            </div>
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button
                                    className="div-center"
                                    variant="contained"
                                    size="small"
                                    onClick={this.onCompanyEmailClick.bind(this)}
                                >
                                    <EmailIcon />
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                <Card className="card offset-lg-2 col-lg-8 offset-md-2 col-md-8 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={(
                        <div>
                            {"Ou nous contacter via "}
                            <Link to={CONTACT_LINK} onClick={this.redirectToContactUsForm} href="#" >ce formulaire de contact</Link>
                        </div>)} />
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        localAgency: state.companies.localAgency,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLocalAgency: (userId, allSites, customerSiteId) => dispatch(getLocalAgency(userId, allSites, customerSiteId)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(ContactUs);
